export default __webpack_public_path__ + "static/media/Bg1.3789a845.jpg";